import { Box, Card, CardContent, Grid2 } from "@mui/material";

import { Decimal } from "classes/DecimalClasses";

import { CardGrid } from "components/CardGrid";
import { FrmFieldGrid } from "components/FrmFieldGrid";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { FrmTextField } from "components/formFields/FrmTextField";
import { CardHeader } from "components/formFields/formCards/CardHeader";
import { FrmUnit } from "components/formFields/frm/FrmUnit";
import { HoverHelp } from "components/utility/HoverHelp";

import { i18n } from "services/i18nService";
import { PACKAGE_TYPE_OPTIONS } from "services/sosInventoryService/upsShipment/schema";

export function PackageInfo(props) {
  const {
    record,
    onChange,
    onScalarChangeAndFetchRates,
    onChangeAndFetchRates,
    isInError,
  } = props;

  return (
    <Card variant="outlined">
      <CardContent>
        <Box sx={{ mb: 1 }}>
          <CardHeader text={i18n("frmLabel.PackageInfo")} />
        </Box>
        <CardGrid>
          <FrmFieldGrid gridAutoFlow="dense">
            <FrmSelectFromObjects
              disableClearable
              name="packagingCode"
              label={i18n("frmLabel.PackageType")}
              value={record.packagingCode ? { id: record.packagingCode } : null}
              onValueChange={onScalarChangeAndFetchRates}
              options={PACKAGE_TYPE_OPTIONS}
              error={isInError("packagingCode")}
            />
            <FrmTextField
              name="refNumber"
              label={i18n("frmLabel.ReferenceNumber1")}
              onValueBlur={onChange}
              value={record.refNumber}
            />
            <FrmTextField
              name="refNumber2"
              label={i18n("frmLabel.ReferenceNumber2")}
              onValueBlur={onChange}
              value={record.refNumber2}
            />
            {record.returnServiceCode && (
              <FrmTextField
                name="returnMerchandiseDescription"
                label={i18n("frmLabel.MerchandiseDescription")}
                onValueBlur={onChange}
                value={record.returnMerchandiseDescription}
                error={isInError("returnMerchandiseDescription")}
              />
            )}
            <Grid2 container spacing={2}>
              <Grid2 size={3.66}>
                <FrmTextField
                  name="declaredValue"
                  number
                  label={i18n("frmLabel.DeclaredValue")}
                  onValueBlur={(name, value) =>
                    onChange(name, new Decimal(value))
                  }
                  value={record.declaredValue}
                />
              </Grid2>
            </Grid2>
          </FrmFieldGrid>
          <FrmUnit
            name="weightUnit"
            value={record.weightUnit}
            onValueChange={onChange}
            sx={{ gap: 2, justifyContent: "start" }}
          />
          <Grid2 container spacing={2}>
            <Grid2 size={3.66}>
              <FrmTextField
                name="weight"
                number
                label={i18n("frmLabel.Weight")}
                onValueBlur={(name, value) =>
                  onChangeAndFetchRates(name, new Decimal(value))
                }
                value={record.weight}
                error={isInError("weight")}
              />
            </Grid2>
          </Grid2>
          <FrmUnit
            name="dimensionUnit"
            value={record.dimensionUnit}
            onValueChange={onChange}
            sx={{ gap: 2, justifyContent: "start" }}
          />
          <Grid2 sx={{ alignItems: "center" }} container spacing={2}>
            <Grid2 size={3.66}>
              <FrmTextField
                number
                name="length"
                label={i18n("frmLabel.Length")}
                onValueBlur={(name, value) =>
                  onChangeAndFetchRates(name, new Decimal(value))
                }
                value={record.length}
                error={isInError("length")}
              />
            </Grid2>
            <Grid2 size={3.66}>
              <FrmTextField
                name="width"
                number
                label={i18n("frmLabel.Width")}
                onValueBlur={(name, value) =>
                  onChangeAndFetchRates(name, new Decimal(value))
                }
                value={record.width}
                error={isInError("width")}
              />
            </Grid2>
            <Grid2 size={3.66}>
              <FrmTextField
                name="height"
                number
                label={i18n("frmLabel.Height")}
                onValueBlur={(name, value) =>
                  onChangeAndFetchRates(name, new Decimal(value))
                }
                value={record.height}
                error={isInError("height")}
              />
            </Grid2>
            <Grid2 sx={{ mt: "0.5rem" }} size={1}>
              <HoverHelp title={i18n("hoverHelp.OwnPackaging")} />
            </Grid2>
          </Grid2>
        </CardGrid>
      </CardContent>
    </Card>
  );
}
